import React from 'react';

const DonationModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleVenmoClick = () => {
    // Replace with your actual Venmo link
    window.open('https://venmo.com/u/TherapeuticRiding-atNormandyFa', '_blank');
  };

  const handleGiveButterClick = () => {
    // Replace with your actual GiveButter link
    window.open('https://givebutter.com/fYR0Ep', '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 p-8 max-w-md w-full mx-auto shadow-2xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white/70 hover:text-white text-2xl font-bold transition-colors"
        >
          ×
        </button>

        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-white drop-shadow-lg mb-4">
            Thanks for Your Support!
          </h2>
          <p className="text-white/90 drop-shadow text-lg">
            Please choose your preferred donation method.
          </p>
        </div>

        {/* Donation Options */}
        <div className="space-y-4">
          {/* Venmo Option */}
          <button
            onClick={handleVenmoClick}
            className="w-full bg-blue-500/20 hover:bg-blue-500/30 backdrop-blur border border-blue-300/30 rounded-xl p-6 transition-all duration-300 group"
          >
            <div className="flex items-center justify-center space-x-4">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M13.454 9.046h1.44l.888-5.74H14.35c-.024-.002-2.581.024-4.196 1.733-1.547 1.644-1.547 3.719-1.547 4.167h-2.2v2.647h2.2v8.127h2.647v-8.127h2.4l.8-2.647h-3.2c0-.448 0-1.856.888-2.72.64-.624 1.462-.648 1.712-.648z"/>
                </svg>
              </div>
              <div className="text-left">
                <h3 className="text-xl font-bold text-white drop-shadow-lg">Venmo</h3>
                <p className="text-white/80 drop-shadow">Quick mobile payments</p>
              </div>
              <svg className="w-6 h-6 text-white/70 group-hover:text-white transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </div>
          </button>

          {/* GiveButter Option */}
          <button
            onClick={handleGiveButterClick}
            className="w-full bg-yellow-500/20 hover:bg-yellow-500/30 backdrop-blur border border-yellow-300/30 rounded-xl p-6 transition-all duration-300 group"
          >
            <div className="flex items-center justify-center space-x-4">
              <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <div className="text-left">
                <h3 className="text-xl font-bold text-white drop-shadow-lg">GiveButter</h3>
                <p className="text-white/80 drop-shadow">Secure online donations</p>
              </div>
              <svg className="w-6 h-6 text-white/70 group-hover:text-white transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </div>
          </button>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-white/70 drop-shadow text-sm">
            Your donation helps us to continue providing therapeutic riding services at Normandy Farms.
          </p>
        </div>

        {/* Contact Info */}
        <div className="mt-6 pt-6 border-t border-white/20">
          <div className="text-center">
            <p className="text-white/80 drop-shadow text-sm mb-2">
              Questions about donations?
            </p>
            <p className="text-white drop-shadow font-semibold">
              Call us at (410) 923-6800
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationModal; 